import React from "react";
import "./cards.scss"

const MarryCard = ({ img, title,des }) => {
  return (
    <div className="d-flex flex-column justify-content-center text-center align-items-center">
      <div className="image_container">
        <img src={img} alt="" />
      </div>
      <p className="marry_text">{title}</p>
      {des && <p>{des}</p>}
    </div>
  );
};

export default MarryCard;
